import { Injectable } from '@angular/core';
import { BeehiveApiService } from '../beehive-api.service';
import { ActivityRole } from '../activity/lib/activity.interfaces';
import { Staff } from '../staff/staff.model';
import { WageSchema } from './wage-schema.model';
import { map, throwError } from 'rxjs';
import { differenceInYears } from 'date-fns';
import { getWageSchemaWage, WageSchemaError } from './lib/wage-schema.util';
import { FilterOperator } from '../api.operators';

@Injectable({ providedIn: 'root' })
export class WageSchemaService extends BeehiveApiService<WageSchema> {
  protected readonly entityType = WageSchema;
  protected readonly endpoint = 'wage-schemas';

  getWage(staff: Staff, role: ActivityRole, date = new Date()) {
    if (!staff.dateOfBirth) {
      return throwError(
        () => new WageSchemaError($localize`Missing date of birth.`),
      );
    }
    const age = differenceInYears(date, staff.dateOfBirth);
    return this.list({
      filters: {
        validFrom: [FilterOperator.LT, date],
        validUntil: [FilterOperator.GT, date],
      },
      sorts: [['validFrom', 'DESC']],
    }).pipe(
      map((schemas) => schemas[0]),
      map((schema) => {
        if (!schema)
          throw new WageSchemaError($localize`No active wage schemas found.`);
        return {
          name: schema.name,
          wage: getWageSchemaWage(schema, role, age),
        };
      }),
    );
  }
}
